import React, { useEffect, useCallback, useState } from 'react';
import AppLayout from '../../component/appLayout';
import { captureException } from '../../services/logService';
import { isEmpty } from '../../helpers/common';
import { getUserWorkspacePreferenceData } from '../../helpers/firebaseHelper';
import TasksDataV2 from '../../component/tasks';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { syncTasks } from '../../services/syncService';
import { MY_TASKS_GROUP_FILTER_TYPE } from '../../global/constants';

const MyTasks: React.FC = () => {
  // States
  const [loading, setLoading] = useState(false);

  //Mobx variables
  const { currentUser, taskStore, workspaceStore } = rootStore;
  const { myTasksFilter } = taskStore;
  const { currentWorkspace: workspace } = workspaceStore;

  const loadData = useCallback(async () => {
    try {
      if (!isEmpty(workspace?.id)) {
        setLoading(true);
        // Start before the preference await so it joins appInit's in-flight task fetch instead of firing a second one
        syncTasks();
        // Get my task filter from user preference
        const myTaskFilter = await getUserWorkspacePreferenceData('my_task_filter');
        rootStore.taskStore.setMyTasksFilter(myTaskFilter?.group_by ?? MY_TASKS_GROUP_FILTER_TYPE.DUE_DATE);

        setLoading(false);
      }
    } catch (e) {
      captureException(e);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspace?.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <AppLayout>
      <TasksDataV2
        data={currentUser?.filteredTasks || []}
        loading={loading}
        isMyTask={true}
        loadData={loadData}
        myTasksFilter={myTasksFilter}
      />
    </AppLayout>
  );
};

export default observer(MyTasks);
